module.exports = __webpack_public_path__ + "static/media/door_arrow_right_outline.61a48742.svg";